import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/512c25b6/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { StructuredListWrapper, StructuredListHead, StructuredListBody, StructuredListRow, StructuredListInput, StructuredListCell, OrderedList, ListItem } from 'carbon-components-react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">How it works</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Accessibility considerations</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Resources</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Accessibility testing</AnchorLink>
    </AnchorLinks>
    <h2>{`How it works`}</h2>
    <p>{`The text input components are form fields that are provided for user input of text information. The validation message should be included to advise the user of text that is input incorrectly or a required field that is missing. The optional helper text should be used to provide instructions to help users understand how to complete the text field as well as indicate any required and optional input, data formats, and other relevant information.`}</p>
    <h2>{`Accessibility considerations`}</h2>
    <ol>
      <li parentName="ol">{`Provide labels and instructions that are clear and concise.`}</li>
      <li parentName="ol">{`Provide `}<a parentName="li" {...{
          "href": "https://www.w3.org/WAI/tutorials/forms/instructions/"
        }}>{`instructions`}</a>{` for completing the field. For example, Passwords must contain at least 8 letters and/or numbers.`}</li>
      <li parentName="ol">{`If the text input is a required field include the `}<a parentName="li" {...{
          "href": "https://www.w3.org/TR/WCAG20-TECHS/ARIA2.html"
        }}><inlineCode parentName="a">{`aria-required`}</inlineCode>{` property`}</a>{` and indicate that it is a required field and use the validation message for input errors.`}</li>
    </ol>
    <h2>{`Resources`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.w3.org/WAI/tutorials/forms/labels/"
        }}>{`W3C Web Tutorial: Labeling Controls`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.w3.org/WAI/tutorials/forms/instructions/"
        }}>{`W3C Web Tutorial: Form Instructions`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/able/guidelines/ci162/accessibility_checklist.html"
        }}>{`IBM Accessibility Checklist Checkpoint`}</a>{`:`}<ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/info_and_relationships.html"
            }}>{`1.3.1 Information and Relationships`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "http://www.w3.org/TR/2016/NOTE-UNDERSTANDING-WCAG20-20161007/content-structure-separation-programmatic.html"
            }}>{`1.3.1`}</a>{`)`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/error_id.html"
            }}>{`3.3.1 Error Identification`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "https://www.w3.org/TR/UNDERSTANDING-WCAG20/minimize-error-identified.html"
            }}>{`3.3.1`}</a>{`)`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/labels_or_instructions.html"
            }}>{`3.3.2 Labels and Instructions`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "http://www.w3.org/TR/UNDERSTANDING-WCAG20/minimize-error-cues.html"
            }}>{`3.3.2`}</a>{`)`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/error_suggestion.html"
            }}>{`3.3.3 Error Suggestion`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "http://www.w3.org/TR/UNDERSTANDING-WCAG20/minimize-error-suggestions.html"
            }}>{`3.3.3`}</a>{`)`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/name_role_value.html"
            }}>{`4.1.2 Name, Role, Value`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "https://www.w3.org/WAI/WCAG21/Understanding/name-role-value"
            }}>{`4.2.1`}</a>{`)`}</li>
        </ul></li>
    </ul>
    <h2>{`Accessibility testing`}</h2>
    <p>{`Accessibility issues are tracked in the `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon/milestones"
      }}>{`Carbon Component GitHub repository`}</a>{`.`}</p>
    <h3>{`Automated test`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListHead mdxType="StructuredListHead">
        <StructuredListRow head mdxType="StructuredListRow">
          <StructuredListCell head mdxType="StructuredListCell">
            Automated test environment
          </StructuredListCell>
          <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - macOS Mojave version 10.14.6 with VoiceOver
            <br />
            - Chrome version 77.0.3865.90
            <br />
            - Dynamic Assessment Plugin (DAP) version 1.8.0.0 - IBM
            Accessibility WCAG 2.1 Sept. 2019 Ruleset
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>DAP test:</strong>
            <br />- No violations
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>
    <h3>{`macOS screen reader tests`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListHead mdxType="StructuredListHead">
        <StructuredListRow head mdxType="StructuredListRow">
          <StructuredListCell head mdxType="StructuredListCell">Environment </StructuredListCell>
          <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - macOS Mojave version 10.14.6 with VoiceOver
            <br />
            - Chrome version 77.0.3865.90
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>
              VoiceOver(VO) text input fully controlled toggle password
              visibility test:
            </strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Control-Option-Shift Down Arrow to enter the Web area.
              </ListItem>
              <ListItem mdxType="ListItem">
                Control-Option-Right Arrow to the text input label. VO announces
                the label and that its a text element.
              </ListItem>
              <ListItem mdxType="ListItem">
                Control-Option-Right Arrow to the optional helper text. VO
                announces the label and that its a text element.
              </ListItem>
              <ListItem mdxType="ListItem">
                Control-Option-Right Arrow to the text input field. VO announces
                the number of characters, and that it is a secure text field
                that will not be spoken by VO.
              </ListItem>
              <ListItem mdxType="ListItem">
                Control-Option-Right Arrow to the icon and VO announces that it
                is a show password button.
              </ListItem>
              <ListItem mdxType="ListItem">Press Space and the password is displayed.</ListItem>
              <ListItem mdxType="ListItem">
                Control-Option-Left Arrow to the Text Input field and VO
                announces the password.
              </ListItem>
              <ListItem mdxType="ListItem">
                Tab to the Hide Password button. VO announces the label and that
                it is a button.
              </ListItem>
              <ListItem mdxType="ListItem">
                Tab to the Show Password button. VO announces the label and that
                it is a button.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - macOS Mojave version 10.14.6 with VoiceOver
            <br />
            - Chrome version 77.0.3865.90
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>VoiceOver(VO) text area test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Control-Option-Shift Down Arrow to enter the Web area.
              </ListItem>
              <ListItem mdxType="ListItem">
                Control-Option-Right Arrow to the Text Area label. VO announces
                the label and that its a text element.
              </ListItem>
              <ListItem mdxType="ListItem">
                Control-Option-Right Arrow to the Optional helper text. VO
                announces the label and that its a text element.
              </ListItem>
              <ListItem mdxType="ListItem">
                Control-Option-Right Arrow to the Text Area. VO announces the
                placeholder text and that it is a text area.
              </ListItem>
              <ListItem mdxType="ListItem">
                Enter text in the text field. VO announces each character as it
                is typed.
              </ListItem>
              <ListItem mdxType="ListItem">
                Tab out of the Text Area and then tab back. VO announces the
                entered text.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>
    <h3>{`Windows screen reader tests`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListHead mdxType="StructuredListHead">
        <StructuredListRow head mdxType="StructuredListRow">
          <StructuredListCell head mdxType="StructuredListCell">Environment</StructuredListCell>
          <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - Microsoft Windows 10
            <br />
            - Firefox version 68
            <br />
            - JAWS 18
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>
              JAWS text input fully controlled toggle password visibility test:
            </strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">Alt-Down area. JAWS announces the labels.</ListItem>
              <ListItem mdxType="ListItem">
                Tab to the text input field. JAWS announces that it is the main
                region, password, label, type and text.
              </ListItem>
              <ListItem mdxType="ListItem">
                Tab to the icon and JAWS announces that it is a show password
                button.
              </ListItem>
              <ListItem mdxType="ListItem">
                Space and Enter key can be used to show and hide the password.
              </ListItem>
              <ListItem mdxType="ListItem">
                Shift-Tab to go back to the text input field and JAWS announces
                the password when it is displayed.
              </ListItem>
              <ListItem mdxType="ListItem">
                Tab to the Show Password button. JAWS announces the label and
                that it is a button.
              </ListItem>
              <ListItem mdxType="ListItem">
                Press Space on the Show Password button. The password displays.
              </ListItem>
              <ListItem mdxType="ListItem">
                Tab to the Hide Password button. JAWS announces the label and
                that it is a button.
              </ListItem>
              <ListItem mdxType="ListItem">
                Press Space on the Hide Password button. The password is hidden.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - Microsoft Windows 10
            <br />
            - Firefox 68
            <br />
            - JAWS 18
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>JAWS text area test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Alt-Down Arrow. JAWS announces the label and that its a text
                element.
              </ListItem>
              <ListItem mdxType="ListItem">
                Tab to the text area. JAWS announces the main region, text area
                label and that it contains text.
              </ListItem>
              <ListItem mdxType="ListItem">
                Enter text in the text area. JAWS announces each character as it
                is typed.
              </ListItem>
              <ListItem mdxType="ListItem">
                Tab to move out of the text area and then Shift-Tab to go back.
                Press Insert-Up Arrow. VO announces the entered text.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>
    <h3>{`iOS screen reader tests`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListRow head mdxType="StructuredListRow">
        <StructuredListCell head mdxType="StructuredListCell">Environment </StructuredListCell>
        <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
      </StructuredListRow>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - iOS version 13.1.3 with VoiceOver
            <br />
            - Safari version 13.1.3
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>
              VoiceOver(VO) text input fully controlled toggle password
              visibility Test:
            </strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Swipe Right to the text input label. VO announces the label and
                that its a text element.
              </ListItem>
              <ListItem mdxType="ListItem">
                Swipe Right to the optional helper text. VO announces the label
                and that its a text element.
              </ListItem>
              <ListItem mdxType="ListItem">
                Swipe Right to the text input field. VO announces the number of
                characters, and that it is a secure text field that will not be
                spoken by VO. As well as character mode and insertion point at
                end of text.
              </ListItem>
              <ListItem mdxType="ListItem">
                Swipe Right to the icon and VO announces that it is a show
                password button.
              </ListItem>
              <ListItem mdxType="ListItem">Double Tap and the password is displayed.</ListItem>
              <ListItem mdxType="ListItem">
                Swipe Left to go back to the text input field and VO announces
                the password.
              </ListItem>
              <ListItem mdxType="ListItem">
                Swipe Right to the Hide Password button. VO announces the label
                and that it is a button.
              </ListItem>
              <ListItem mdxType="ListItem">
                Swipe Right to the Show Password button. VO announces the label
                and that it is a button.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - iOS version 13.1.3 with VoiceOver
            <br />
            - Safari version 13.1.3
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>VoiceOver(VO) text area test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Swipe Right to the text area label. VO announces the label and
                that its a text element.
              </ListItem>
              <ListItem mdxType="ListItem">
                Swipe Right to the Optional helper text. VO announces the label
                and that its a text element.
              </ListItem>
              <ListItem mdxType="ListItem">
                Swipe Right to the text area. VO announces the placeholder text
                and that it is a text area.
              </ListItem>
              <ListItem mdxType="ListItem">
                Enter text in the text field. VO announces each character as it
                is typed.
              </ListItem>
              <ListItem mdxType="ListItem">
                Swipe Right to move out of the text area and then Swipe Left to
                go back. VO announces the entered text.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      